/** Campos sensíveis — nunca mostrar valores na UI de auditoria. */
const REDACTED_KEYS = new Set([
    'password',
    'passwordHash',
    'secret',
    'totpSecret',
    'mfaSecret',
    'refreshToken',
    'accessToken',
]);
const FIELD_LABELS = {
    name: 'Nome',
    username: 'Username',
    email: 'Email',
    phoneNumber: 'Telefone',
    role: 'Papel',
    isActive: 'Ativo',
    isMfaEnabled: 'MFA',
    plan: 'Plano',
    isQa: 'Organização QA',
    legalName: 'Razão social',
    taxIdType: 'Tipo fiscal',
    taxId: 'NIF',
    timezone: 'Fuso horário',
    preferredLanguage: 'Idioma',
    messagingAiEnabled: 'IA mensagens',
    status: 'Estado',
    sourceKey: 'Chave',
    title: 'Título',
    passwordReset: 'Reset de password',
};
function isPlainObject(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function formatValue(key, value) {
    if (REDACTED_KEYS.has(key))
        return '••••••••';
    if (value === null || value === undefined)
        return '—';
    if (typeof value === 'boolean')
        return value ? 'sim' : 'não';
    if (typeof value === 'string' || typeof value === 'number')
        return String(value);
    if (Array.isArray(value))
        return value.length === 0 ? '[]' : JSON.stringify(value);
    if (isPlainObject(value)) {
        const keys = Object.keys(value);
        return keys.length === 0 ? '{}' : JSON.stringify(value);
    }
    return String(value);
}
function collectKeys(before, after) {
    const keys = new Set();
    for (const k of Object.keys(before ?? {}))
        keys.add(k);
    for (const k of Object.keys(after ?? {}))
        keys.add(k);
    return [...keys].sort();
}
/** Diff legível entre snapshots before/after (top-level, sem JSON cru). */
export function computeAuditDiff(before, after) {
    if (!before && !after)
        return [];
    const keys = collectKeys(before, after);
    return keys.map((field) => {
        const b = before?.[field];
        const a = after?.[field];
        const beforeStr = formatValue(field, b);
        const afterStr = formatValue(field, a);
        return {
            field,
            label: FIELD_LABELS[field] ?? field,
            before: beforeStr,
            after: afterStr,
            changed: beforeStr !== afterStr,
        };
    });
}
